/**
 * @generated SignedSource<<890a1d3222e76dcad55d4fb057e04566>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type portals_user$data = {
  readonly lastCompletedClass: {
    readonly courseClass: {
      readonly nextClass?: {
        readonly " $fragmentSpreads": FragmentRefs<"portals_coursePortal">;
      } | null | undefined;
    };
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "portals_user";
};
export type portals_user$key = {
  readonly " $data"?: portals_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"portals_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "club"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "portals_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "club",
          "variableName": "club"
        }
      ],
      "concreteType": "CompletedClass",
      "kind": "LinkedField",
      "name": "lastCompletedClass",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "courseClass",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "nextClass",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "portals_coursePortal"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "CourseContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e0e41688c5fbfb49adaabd4caf5721b3";

export default node;
